import React from 'react';
import { VehicleDetailsButtonDTO, VehicleDataDTO } from '../../../../api/generated';
import { VehicleDetailsButton } from './VehicleDetailsButton';
import { useAppSelector } from '../../../../app/hooks';
import {vehicleDetailsButtonsSelector} from '../../../chatbotSlice';

interface VehicleDetailsButtonsContainerProps {
  vehicle: VehicleDataDTO;
  onClose: () => void;
}

const MAX_BUTTONS = 2;

export const VehicleDetailsButtonsContainer: React.FC<VehicleDetailsButtonsContainerProps> = ({ vehicle, onClose }) => {
  const buttons = useAppSelector(vehicleDetailsButtonsSelector);

  // Only show up to MAX_BUTTONS buttons
  const visibleButtons = buttons.slice(0, MAX_BUTTONS);

  if (visibleButtons.length === 0) {
    return <></>
  }

  return (
    <div className="flex gap-3 mb-4">
      {visibleButtons.map((button: VehicleDetailsButtonDTO, index: number) => (
        <VehicleDetailsButton
          key={button.id || index}
          button={button}
          vehicle={vehicle}
          onClose={onClose}
        />
      ))}
    </div>
  );
};
